/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Sex_MaleInputs */

const en_us2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Male`)
};

const pt_br2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculino`)
};

const es_419_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculino`)
};

const pt_pt2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculino`)
};

const fr_fr2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculin`)
};

const de_de2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Männlich`)
};

const it_it2_body_assessment_sex_male = /** @type {(inputs: Body_Assessment_Sex_MaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschile`)
};

/**
* | output |
* | --- |
* | "Male" |
*
* @param {Body_Assessment_Sex_MaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_sex_male = /** @type {((inputs?: Body_Assessment_Sex_MaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Sex_MaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_sex_male(inputs)
	if (locale === "es-419") return es_419_body_assessment_sex_male(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_sex_male(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_sex_male(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_sex_male(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_sex_male(inputs)
	return en_us2_body_assessment_sex_male(inputs)
});
export { body_assessment_sex_male as "body-assessment.sex_male" }